export const canadian_provinces = [
  {
    value: "BC",
  },
  {
    value: "ON",
  },
  {
    value: "AB",
  },
  {
    value: "MB",
  },
  {
    value: "NB",
  },
  {
    value: "QC",
  },
  {
    value: "NS",
  },
  {
    value: "PE",
  },
  {
    value: "SK",
  },
  {
    value: "NL",
  },
  {
    value: "YT",
  },
  {
    value: "NT",
  },
  {
    value: "NU",
  },
];

export const referral_options = [
  {
    value: "Friend/Relatives",
  },
  {
    value: "Instagram",
  },
  {
    value: "Others",
  },
];

export const hull_coverage_requested = [
  {
    value: "None",
  },
  {
    value: "All risk flight & ground",
  },
  {
    value: "All risk ground only",
  },
  {
    value: "Liability only",
  },
];

export const aircraft_storage = [
  {
    value: "Hangared",
  },
  {
    value: "Tied",
  },
  {
    value: "Not Tied Down",
  },
  {
    value: "Moored",
  },
];

export const trip_duration_options = [
  {
    value: "Months",
  },
  {
    value: "Days",
  },
];

export const HANGARED_AIRCRAFT_STORAGE = "Hangared";
export const MOORED_AIRCRAFT_STORAGE = "Moored";

export const APPLICATIONS_SEARCH_OPTIONS = [
  { label: "Insured Name", value: "INSURED_NAME" },
  { label: "Aircraft", value: "AIRCRAFT" },
];

export const TPL_OPTIONS = [
  { label: "CA$100,000", value: 100_000 },
  { label: "CA$500,000", value: 500_000 },
  { label: "CA$1,000,000", value: 1_000_000 },
  { label: "CA$2,000,000", value: 2_000_000 },
  { label: "CA$3,000,000", value: 3_000_000 },
  { label: "CA$5,000,000", value: 5_000_000 },
  { label: "CA$10,000,000", value: 10_000_000 },
];

export const PASSENGER_OPTIONS = [
  { label: "CA$100,000", value: 100_000 },
  { label: "CA$200,000", value: 200_000 },
  { label: "CA$300,000", value: 300_000 },
  { label: "CA$500,000", value: 500_000 },
  { label: "None", value: 0 },
];

export const PREMISES_OPTIONS = [
  { label: "CA$1,000,000", value: 1_000_000 },
  { label: "CA$2,000,000", value: 2_000_000 },
  { label: "CA$3,000,000", value: 3_000_000 },
  { label: "CA$5,000,000", value: 5_000_000 },
  { label: "CA$10,000,000", value: 10_000_000 },
  { label: "None", value: 0 },
];

export const QUOTE_STATUSES_MAP = {
  Pending: "default",
  "In Progress": "processing",
  Quoted: "warning",
  Bound: "success",
  "Not Bound - Try Again Next Year": "error",
  "Not Bound - Closed": "error",
};

export const QUOTE_STATUS_DISPLAY = {
  Pending: "Pending",
  "In Progress": "In Progress",
  Quoted: "Quoted",
  Bound: "Bound",
  "Not Bound - Try Again Next Year": "Try Again Next Year",
  "Not Bound - Closed": "Closed",
};

export const RENEWAL_STATUSES_MAP = {
  not_sent: "default",
  sent: "processing",
  completed: "success",
  cancelled: "error",
};

export const RENEWAL_STATUS_DISPLAY_SUBSET = {
  not_sent: "Not Sent",
  sent: "Sent",
};

export const RENEWAL_STATUS_DISPLAY = {
  not_sent: "Not Sent",
  sent: "Sent",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const QUOTE_STATUS_FILTERS = Object.entries(QUOTE_STATUSES_MAP).map(
  ([value, _]) => ({
    text: QUOTE_STATUS_DISPLAY[value],
    value,
  })
);

export const QUOTE_STATUS_SELECT_OPTIONS = Object.keys(QUOTE_STATUSES_MAP).map(
  (status) => ({
    label: status,
    value: status,
  })
);

export const RENEWAL_STATUS_FILTERS = Object.entries(RENEWAL_STATUSES_MAP).map(
  ([value, _]) => ({
    text: RENEWAL_STATUS_DISPLAY[value],
    value,
  })
);
